import { createContext, useContext, useState, useEffect } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [authUser, setAuthUser] = useState(null);
  const [authChecked, setAuthChecked] = useState(false);

  useEffect(() => {
    // Read ONLY from sessionStorage — no localStorage
    const storedUser = sessionStorage.getItem("user_info");

    if (storedUser) {
      try {
        setAuthUser(JSON.parse(storedUser));
      } catch {
        sessionStorage.clear();
      }
    }

    setAuthChecked(true);
  }, []);

  const login = (user, access, refresh) => {
    // Save everything to sessionStorage only
    sessionStorage.setItem("user_info", JSON.stringify(user));
    if (access)  sessionStorage.setItem("access", access);
    if (refresh) sessionStorage.setItem("refresh", refresh);
    // Also keep a "user" key for legacy checks in AdminTracking
    sessionStorage.setItem("user", JSON.stringify(user));
    setAuthUser(user);
  };

  const logout = () => {
    sessionStorage.clear();
    setAuthUser(null);
  };

  return (
    <AuthContext.Provider value={{ authUser, login, logout, authChecked }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
